import { Component, ContentChildren, QueryList, AfterContentInit, Input  } from '@angular/core';
import { TabPageComponent } from './tab-page.component';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'tab-control',
    imports: [CommonModule],
    templateUrl: './tab-control.component.html',
    styleUrls: ['./tab-control.component.scss']
})
export class TabControlComponent implements AfterContentInit {
    @ContentChildren(TabPageComponent)
    tabs: QueryList<TabPageComponent> = new QueryList<TabPageComponent>();

    @Input()
    activeTab: string = '';

    ngAfterContentInit() {
        this.tabs.forEach(tab => tab.active = false);

        if (this.activeTab) {
            const tabToActivate = this.tabs.find(tab => tab.title === this.activeTab);

            if (tabToActivate) {
                tabToActivate.active = true;
            }
            else {
                this.tabs.first.active = true;
            }
        }
        else {
            this.tabs.first.active = true;
        }
    }

    selectTab(tab: TabPageComponent) {
        this.tabs
            .toArray()
            .forEach(t => t.active = false);

        tab.active = true;
    }
}
